/* eslint-disable react/jsx-props-no-spreading */
import { Col, Row, Form, Input, Button, Divider } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { validateFileList } from 'utils/form/validators';
import { Upload, Accordion, AddButton } from 'components';
import * as fieldMsgs from 'constants/formFieldsMessages';

const Testigos = ({ form, isLoadingImages }) => {
  const formComponent = ({ remove, name, disabled, isLastHallazgo, ...restField }) => (
    <div>
      <div className="formulario-hallazgos">
        <Row gutter={24}>
          <Col xs={10} className="formulario-hallazgos-tabla-header">
            Información del testigo:
          </Col>
          <Col xs={3} className="formulario-hallazgos-tabla-header">
            Identificación anverso:
          </Col>
          <Col xs={3} className="formulario-hallazgos-tabla-header">
            Identificación reverso:
          </Col>
          <Col xs={3} className="formulario-hallazgos-tabla-header">
            Firma digital:
          </Col>
          <Col xs={2} style={{ textAlign: 'center' }} className="formulario-hallazgos-tabla-header">
            Acciones
          </Col>
        </Row>
        <Row>
          <Col xs={10} className="hallazgos-detalle">
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'nombre']}
                  label="Nombre(s):"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Nombre" style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'apPaterno']}
                  label="Primer apellido:"
                  rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                  <Input placeholder="Primer apellido" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item className="" name={[name, 'apMaterno']} label="Segundo apellido:">
                  <Input placeholder="Segundo apellido" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item className="" name={[name, 'identificacion']} label="Identificación:">
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item
                  className=""
                  name={[name, 'folioIdentificacion']}
                  label="Folio de identificación:">
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item className="" name={[name, 'expedidaPor']} label="Expedida por:">
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={4}>
                <Form.Item className="" name={[name, 'edad']} label="Edad:">
                  <Input placeholder="Edad" />
                </Form.Item>
              </Col>
              <Col span={20}>
                <Form.Item className="" name={[name, 'domicilio']} label="Domicilio:">
                  <Input placeholder="Domicilio" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[7, 0]} className="row-formulario-nested">
              <Col span={12}>
                <Form.Item className="" name={[name, 'institucion']} label="Institución:">
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item className="" name={[name, 'cargo']} label="Cargo:">
                  <Input placeholder="Escribe..." />
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-row">
              <Form.Item
                {...restField}
                required
                name={[name, 'idAnverso']}
                className="hallazgos-imagenes-muestra"
                rules={[
                  {
                    validator: validateFileList
                  }
                ]}>
                <Upload disabled={isLoadingImages} loading={isLoadingImages} />
              </Form.Item>
            </div>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-row">
              <Form.Item
                {...restField}
                required
                name={[name, 'idReverso']}
                className="hallazgos-imagenes-muestra"
                rules={[
                  {
                    validator: validateFileList
                  }
                ]}>
                <Upload disabled={isLoadingImages} loading={isLoadingImages} />
              </Form.Item>
            </div>
          </Col>
          <Col xs={3}>
            <div className="hallazgos-imagenes-row">
              <Form.Item
                {...restField}
                required
                name={[name, 'firma']}
                className="hallazgos-imagenes-muestra"
                rules={[
                  {
                    validator: validateFileList
                  }
                ]}>
                <Upload disabled={isLoadingImages} loading={isLoadingImages} />
              </Form.Item>
            </div>
          </Col>
          <Col xs={2}>
            <div className="hallazgos-imagenes-acciones">
              <Button disabled={isLastHallazgo} style={{ height: '2em' }}>
                <DeleteOutlined onClick={() => remove(name)} />
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );

  return (
    <div className="modal-monitoreo-internet-hallazgos">
      <Row gutter={[24, 0]} className="row-formulario">
        <Col span={24} className="col-dos-instrucciones">
          <span className="instruction-span-purple" style={{ paddingLeft: '9px' }}>
            Agrega los registros necesarios.
          </span>
        </Col>
      </Row>
      <Form layout="vertical" form={form}>
        <Form.List name="testigos" initialValue={[{}]}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => {
                  const isLastHallazgo = fields.length <= 1;

                  const testigo = {
                    key: `testigo_${key}`,
                    label: `Testigo ${name + 1}`,
                    forceRender: true,
                    children: formComponent({
                      remove,
                      name,
                      isLastHallazgo,
                      ...restField
                    })
                  };
                  return <Accordion key={key} items={[testigo]} defaultActiveKey={['testigo_0']} />;
                })}
                <Divider />
                <div className="formulario-hallazgos-acciones">
                  <AddButton
                    onClick={() => {
                      add();
                    }}
                    style={{ marginRight: '1em' }}>
                    Agregar Nuevo
                  </AddButton>
                </div>
              </>
            );
          }}
        </Form.List>
      </Form>
    </div>
  );
};

Testigos.propTypes = {
  form: PropTypes.shape({}).isRequired,
  isLoadingImages: PropTypes.bool.isRequired
};

export default Testigos;
